const jwt_customizer = {
    general: 'JWT belirteci özelleştirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
    can_not_create_for_admin_tenant: 'Yönetici kiracı için bir JWT belirteci özelleştirelemez.',
};
export default Object.freeze(jwt_customizer);
